exports.install = function (Vue, ErrorHandler) {
  if (this.installed) {
    return
  }

  this.installed = true

  Object.defineProperty(Vue.prototype, '$errorHandler', {
    get: function get () { return new ErrorHandler() }
  })
}



// WEBPACK FOOTER //
// ./src/configs/error-handler/plugin.js